import { computed,inject } from "vue";

export default function() {
    const DeliveryStore = inject("DeliveryStore");
    const tier = computed (() => {
        if (DeliveryStore.state.delivery) {
            return DeliveryStore.state.delivery.category;
        } else {
            return null;
        }
    });

    return { tier };
}